module.exports = __webpack_public_path__ + "assets/media/morning.b11d6690.mp3";